export default {"src":"/_next/static/media/button-carousel-right.331a663f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};